<template>
    <div class="input-button-type">
        <btn-button-type v-for="(preset, index) in presets" :key="`type-${index}`" v-model="currentButtonType" :preset="preset"/>
<!--        <b-dropdown :variant="currentButtonType">-->
<!--            <template #button-content>-->
<!--                <span v-tr>Custom|Personnalisé</span>-->
<!--            </template>-->
<!--            <b-dropdown-item v-for="variant in variants" :key="`v-${variant}`">-->
<!--                <b-btn block :variant="variant">{{variant}}</b-btn>-->
<!--            </b-dropdown-item>-->
<!--        </b-dropdown>-->
    </div>
</template>

<script>
import BtnButtonType from "@/components/editor/properties/inputs/btn-button-type.vue";

// input-button-type #hot-reload-debug
export default {
    name: `input-button-type`,
    components: {BtnButtonType},
    props: {
        value: {type: String}
    },
    data() {
        return {
            presets: [`solid`, `outline`, `light`, `text`, `custom`],
            variants: [`primary`, `secondary`, `light`, `info`, `success`, `warning`, `danger`, `outline-primary`, `outline-secondary`, `outline-light`, `outline-info`, `outline-success`, `outline-warning`, `outline-danger`, `light-primary`, `light-secondary`, `light-info`, `light-success`, `light-warning`, `light-danger`]
        }
    },
    computed: {
        currentButtonType: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit(`input`, value);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
